import { Blueprint } from '../../blueprint.class';
import { Size } from '../../../../types';
import { ToolResult } from '../../types';

export interface UpdateIslandMinimumSizeArgs {
	islandId: string;
	width?: number;
	height?: number;
	depth?: number;
}

export const updateIslandMinimumSizeTool = (blueprint: Blueprint, { islandId, width, height, depth }: UpdateIslandMinimumSizeArgs): ToolResult => {
	if (!islandId) return { success: false, error: 'Missing islandId. Use list_islands to get valid island IDs.' };

	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	const island = kitchen.design.islands.children.find((i) => i.id === islandId);
	if (!island) return { success: false, error: `Island '${islandId}' not found. Use list_islands to get valid island IDs.` };

	// Get current minimum size as fallback for omitted dimensions
	const currentMinimum = island.minimumSize;
	const currentSize = island.size as Size;

	const newWidth = width ?? currentMinimum?.width ?? currentSize.width;
	const newHeight = height ?? currentMinimum?.height ?? currentSize.height;
	const newDepth = depth ?? currentMinimum?.depth ?? (currentSize.depth as number);

	island.minimumSize = { width: newWidth, height: newHeight, depth: newDepth };

	return {
		success: true,
		message: `Island '${islandId}' minimum size updated to ${newWidth}x${newHeight}x${newDepth} inches.`
	};
};
